<template>
  <div class="main-view home-container">
		<div class="bg-container home-hero" :style="{'background-image': 'url(' + require(`../assets/img/bgs/bg-home-waves.svg`) + ')'}">
			<div class="template-inner flex-row breakdown">
				<div class="hero-copy-container one-half">
					<h1 class="hero-header">Create{{'\xa0'}}a{{'\xa0'}}climate for{{'\xa0'}}change</h1>
					<p class="hero-body">Boost recognition, performance, wellness and teamwork, while directly funding tree planting around the{{'\xa0'}}world.</p>
					<button class="header-btn" @click="$router.push('/book-a-demo')">book a demo</button>
				</div>
				<div class="hero-silhouette one-half">
					<img src="@/assets/img/silhouettes/home-silhouette-optimized.png" alt="" class="home-silhouette">
					<div class="hero-screenshot-container">
						<img src="@/assets/img/home/give-awards.png" alt="" class="give-screen" data-aos="zoom-in" data-aos-delay="100">
						<img src="@/assets/img/home/get-rewards.png" alt="" class="get-screen" data-aos="zoom-in" data-aos-delay="200">
						<img src="@/assets/img/home/plant-trees.png" alt="" class="plant-screen" data-aos="zoom-in" data-aos-delay="300">
					</div>
				</div>
			</div>
		</div>
		<div class="home-content">
			<div class="counts-bg-green">
				<!-- <div class="template-inner flex-row breakdown align-start justify-center">

					<div class="one-half count-box flex-col actions-completed mobile-hide">
						<div class="header-icon-container actions"></div>
						<p class="count">8,896,034</p>
						<p class="count-description orange">Evergrow Actions Completed</p>
						<p class="count-tiny">Includes awards sent, rewards redeemed, surveys completed, goals achieved and more</p>
					</div>

					<div class="one-half count-box flex-col trees-planted">
						<div class="header-icon-container trees"></div>
						<p class="count" v-if="interval">{{ interval.community | numeral('0,0') }}</p>
						<p class="count" v-else>.....</p>
						<p class="count-description green">Trees Planted</p>
						<p class="count-tiny">Every completed Evergrow action funds at least 5 new trees</p>
					</div>


				</div> -->
				<div class="template-inner flex-row boosting align-start">
					<div class="one-third">
						<img src="@/assets/img/home/boosting-retention.svg" alt="">
						<p><strong>Boosting Retention</strong></p>
						<p>In a climate where companies are struggling to attract and retain top talent, Evergrow makes work mean more, by rewarding teamwork, motivating performance and directly connecting activity to{{'\xa0'}}eco-action.</p>
					</div>
					<div class="one-third">
						<img src="@/assets/img/home/growing-profitability.svg" alt="">
						<p><strong>Motivating Productivity</strong></p>
						<p>Inspiring remote and distracted employees to be more productive is critical for growth. Evergrow helps employees stay motivated with instant recognition, incentive rewards, wellness gamification and{{'\xa0'}}more.</p>
					</div>
					<div class="one-third">
						<img src="@/assets/img/home/motivating-productivity.svg" alt="">
						<p><strong>Growing Profitability</strong></p>
						<p>Many companies overpay for an expensive patchwork of disconnected recognition, reward and incentive programs. Evergrow’s AI-powered multi-experience app unifies all of these separate features together into a seamless, affordable{{'\xa0'}}solution.</p>
					</div>
				</div>
				<div class="ai-powered flex-col">
					<h2>AI-powered performance recognition,<br>rewards & motivation</h2>
					<p>Evergrow helps companies thrive by empowering their people to change the world. We’ve created a revolutionary AI-powered personalized employee engagement platform that recognizes your team’s best work with the world’s coolest rewards. Evergrow also helps your work environment transform the global environment by funding native tree planting with every{{'\xa0'}}action.</p>
				</div>
				<DashboardBubbles />
			</div>	
			<div class="btn-container flex-col justify-center">
				<button class="header-btn" @click="$router.push('/book-a-demo')">book a demo</button>
			</div>
			<div class="features-breakdown center mobile-hide">
				<div class="flex-row justify-center">
					<div class="feature-icon one">
						<p>Recognition</p>
					</div>
					<div class="feature-spacer">
						<div class="stroke"></div>
						<div class="feature-spacer-inner">+</div>
						<div class="stroke"></div>
					</div>
					<div class="feature-icon two">
						<p>Rewards</p>
					</div>
					<div class="feature-spacer">
						<div class="stroke"></div>
						<div class="feature-spacer-inner">+</div>
						<div class="stroke"></div>
					</div>
					<div class="feature-icon three">
						<p>Savings</p>
					</div>
					<div class="feature-spacer">
						<div class="stroke"></div>
						<div class="feature-spacer-inner">+</div>
						<div class="stroke"></div>
					</div>
					<div class="feature-icon four">
						<p>Climate&nbsp;Action</p>
					</div>
				</div>
			</div>
			<div class="feature-details template-inner">
				<div class="flex-row recognition-detail breakdown">
					<RecognitionBubbles class="one-half"/>
					<div class="one-half padding-left-half">
						<img class="detail-icon" src="@/assets/img/icons/star-orange.svg" alt="">
						<h2>Recognition</h2>
						<p>Recognize and motivate great work by sending quick peer, team and manager awards right from the dashboard.</p>
						<button @click="$router.push('/features/recognition')">learn more</button>
					</div>
				</div>
				<div class="flex-row rewards-detail breakdown">
					<div class="one-half padding-right-half">
						<img class="detail-icon" src="@/assets/img/icons/money-purple.svg" alt="">
						<h2>Rewards</h2>
						<p>Redeem awards for amazing merchandise, gift card and travel experiences from the world’s best loved brands.</p>
						<button @click="$router.push('/features/rewards')">learn more</button>
					</div>
					<RewardsBubbles class="one-half"/>
				</div>
				<div class="flex-row savings-detail breakdown">
					<SavingsBubbles class="one-half"/>
					<div class="one-half padding-left-half">
						<img class="detail-icon" src="@/assets/img/icons/piggy-blue.svg" alt="">
						<h2>Savings</h2>
						<p>Get instant, points-free daily deals for you and your family at local restaurants, attractions and popular retail stores.</p>
						<button @click="$router.push('/features/recognition')">learn more</button>
					</div>
				</div>
				<div class="flex-row climate-action-detail breakdown">
					<div class="one-half padding-right-half">
						<img class="detail-icon" src="@/assets/img/icons/tree-green.svg" alt="">
						<h2>Climate Action</h2>
						<p>Create real change with every employee action funding tree planting and forest conservation around the globe.</p>
						<button @click="$router.push('/features/trees')">learn more</button>
					</div>
					<ClimateBubbles class="one-half"/>
				</div>
			</div>
			<div class="video-section flex-col">
				<h2>Make your work more meaningful,<br> and your impact more powerful</h2>
				<div class="video-container">
					<transition name="fade" mode="out-in">
						<div class="img-transition" @click="playVideo()" v-if="!isHomepageVideoplayer"></div>
						<!-- <iframe v-else src='https://www.youtube.com/embed//VkilDHIIXbo?autoplay=1' frameborder='0' allowfullscreen></iframe> -->
						<iframe v-else src="https://player.vimeo.com/video/504894324?color=ffffff&title=0&byline=0&portrait=0" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
					</transition>
				</div>
				<button @click="$router.push('/book-a-demo')">book a demo</button>

				<div class="testimonials-carousel flex-row">
					<div class="stroke"></div>
					<div class='testimonials-inner flex-row'>
						<agile
							:navButtons="false"
							:dots="false"
							:autoplay="false"
							:fade="true"
							:autoplaySpeed="10000"
						>
							<div class="slide one">
								<img src="@/assets/img/home/bruce.png" class="testimonial-avatar" alt="">
								<div class="copy">
									<p>Disengagement costs American industry hundreds of billions of dollars per year in lost productivity and reduced sales. Extensive research proves that organizations with proactively involved employees consistently outperform their competitors in earnings and growth. Evergrow is a pipeline into the hearts and minds of every employee.</p>
									<p class="author green">Bruce Bolger</p>
									<p class="title green">EEA Managing Director,<br>The Enterprise Engagement Alliance</p>
								</div>
							</div>
							<!-- <div class="slide two">
								<img src="@/assets/img/home/bruce2.png" class="testimonial-avatar" alt="">
								<div class="copy">
									<p>Lorem ipsum dolor sit amet consectetur adipisicing, elit. Officiis, expedita nisi! Assumenda veniam, illo odit alias expedita esse possimus quis nobis beatae laborum voluptate iste distinctio perferendis laudantium perspiciatis saepe!</p>
									<p class="author green">Bruce Bolger2</p>
									<p class="title green">2EEA Managing Director, The Enterprise Engagement Alliance2</p>
								</div>
							</div> -->
						</agile>
					</div>
					<div class="stroke"></div>
				</div>
			</div>
			<div class="multi-experience">
				<div class="template-inner">
					<h2 class="text-center">A seamless multi-experience app</h2>
					<p class="text-center">For years, companies have struggled to find an ideal solution to achieve all of their goals affordably, often patching together disconnected technologies and programs. Mismatching interface designs, terminology and log-in credentials create a patchwork that discourages employees from using the services. Also, data from these individual services are siloed and don’t holistically connect to become meaningful. Evergrow creates a single log-in, seamless experience, that uses AI to connect data as employees use each of the features, creating a uniquely personal engagement journey.</p>
					<div class="flex-row align-start breakdown">
						<div class="one-third">
							<img src="@/assets/img/home/multi-1.svg" alt="">
							<p><strong>Intuitive performance recognition engine</strong></p>
							<p>Evergrow ignites the power of one-click recognition across your organization. Members can instantly recognize a colleague’s great work, birthdays or tenure, with public awards, badges and Evergrow points.</p>
						</div>
						<div class="one-third">
							<img src="@/assets/img/home/multi-2.svg" alt="">
							<p><strong>AI-personalized rewards</strong></p>
							<p>Evergrow helps you recognize great work with the largest collection of the world’s most loved rewards. The Evergrow AI engine curates and suggests the perfect reward to match a member’s unique interests.</p>
						</div>
						<div class="one-third">
							<img src="@/assets/img/home/multi-3.svg" alt="">
							<p><strong>Simplified reward financing</strong></p>
							<p>We’ve made it easier for Evergrow members to get the rewards they want without the wait. Evergrow financing offers low-to-no interest microloans and payroll deduction flexibility so members can buy rewards, even if they don’t have enough points.</p>
						</div>
					</div>
					<div class="flex-row align-start breakdown">
						<div class="one-third">
							<img src="@/assets/img/home/multi-4.svg" alt="">
							<p><strong>AI-personalized savings</strong></p>
							<p>Everybody likes to save, and Evergrow has created the world’s biggest savings hub. Hundreds of thousands of discounts are available on movie tickets, gift cards, travel, events, fashion, electronics and more from brands that people love the most. Evergrow Savings also helps you save everyday at local restaurants, coffee shops and retail stores.</p>
						</div>
						<div class="one-third">
							<img src="@/assets/img/home/multi-5.svg" alt="">
							<p><strong>Activity & wellness tracking</strong></p>
							<p>A healthy team helps grow a healthy business. Connect a fitness tracker (like Fitbit or Apple Watch) to Evergrow and members can earn points for healthy wellness activity. Team or company challenges can even be created, earning points or badge awards.</p>
						</div>
						<div class="one-third">
							<img src="@/assets/img/home/multi-6.svg" alt="">
							<p><strong>Surveys, training & feedback participation</strong></p>
							<p>Want to encourage training completion, feedback, or team participation? Evergrow can be easily linked to reward training, certification, survey completion, feedback submission, or meeting participation.</p>
						</div>
					</div>
					<div class="flex-row align-start breakdown">
						<div class="one-third">
							<img src="@/assets/img/home/multi-7.svg" alt="">
							<p><strong>HomeSpace</strong></p>
							<p>Evergrow helps remote employees stay connected to their peers, teams and managers. HomeSpace is our unique content module that helps create an inspiring, productive work-from-home experience for employees.</p>
						</div>
						<div class="one-third">
							<img src="@/assets/img/home/multi-8.svg" alt="">
							<p><strong>Plant trees around the world</strong></p>
							<p>Every action and transaction within Evergrow funds the planting of new native trees and forest conservation. Trees are natural carbon sinks, absorbing damaging CO2 from the atmosphere and directly helping reduce global warming.</p>
						</div>
						<div class="one-third">
							<img src="@/assets/img/home/multi-9.svg" alt="">
							<p><strong>Evergrow Community & Tree Planting Tracker</strong></p>
							<p>Our Evergrow community of individuals, families, teams and companies around the world will have access to climate change articles, and a tree planting tracker with direct links to each of our special tree planting projects where members can see the results of their hard work.</p>
						</div>
					</div>
					<button @click="$router.push('/features/recognition')">learn more</button>
				</div>
			</div>
			<Demo class="home-demo"></Demo>
		</div>
  </div>
</template>

<script>
	/* eslint-disable */

	import Demo from "../components/Demo"
	import DashboardBubbles from '../components/homepage-bubbles/DashboardBubbles'
	import RecognitionBubbles from '../components/homepage-bubbles/RecognitionBubbles'
	import RewardsBubbles from '../components/homepage-bubbles/RewardsBubbles'
	import SavingsBubbles from '../components/homepage-bubbles/SavingsBubbles'
	import ClimateBubbles from '../components/homepage-bubbles/ClimateBubbles'


	export default {
		name: 'Home',
		data() {
			return {
				isHomepageVideoplayer: false,
				interval: []
			}
		},
		methods: {
			playVideo() {
				this.isHomepageVideoplayer = !this.isHomepageVideoplayer;
			},
			fetchTreeCount: function () {
			  const baseURI = 'https://api-ms.p2motivate.com/evergrow-trees/trees/funded'
			  this.$http.get(baseURI)
			  .then((result) => {
			    this.interval = result.data
			  })
			}
		},
		created () {
			this.fetchTreeCount()
			this.interval = setInterval(() => this.fetchTreeCount(), 30000);
		},
		components: {
			Demo,
			DashboardBubbles,
			RecognitionBubbles,
			RewardsBubbles,
			SavingsBubbles,
			ClimateBubbles
		}
	}
</script>

<style lang="stylus" scoped>
	.bg-container.home-hero 
		background center center / cover no-repeat
		
		.template-inner
			padding-top 140px
			
	.hero-silhouette.one-half 
		display flex
		flex-direction column
		align-items center
		
		img.home-silhouette
			width 400px

	
	.hero-screenshot-container
		width 100%
		margin-left 40px
		
		.give-screen
			width 32%
			position relative
			top -200px
			left 20px
			filter: drop-shadow(0px 20px 40px #00000033);
			
		.get-screen
			width 33%
			position relative
			top -70px
			z-index 100
			filter: drop-shadow(0px 20px 40px #00000033);
			
		.plant-screen
			width 34%
			position relative
			top -230px
			right 20px
			filter: drop-shadow(0px 20px 40px #00000033);
			
	.counts-bg-green
		background-color #00A562
		margin-top -1px
	
	.count-tiny
		font-size 14px  !important
		line-height 20px
		min-height 60px
	
	.header-icon-container.trees
		background-color #008200 !important
	
	.boosting
		margin-bottom 100px
		
	.boosting .one-third img
		margin-bottom 20px
		height 55px

	.boosting .one-third p strong
		font-size 24px
		line-height 32px
		font-weight bold
		
	.boosting .one-third p
		color #fff
		
	.ai-powered
		width 90%
		max-width 1150px
		margin 0 auto 90px
		
		h2, p
			color #fff
			text-align center
			
	.btn-container
		margin-bottom 120px	
			
	// FEATURES SECTION
	.features-breakdown
		margin-bottom 260px
		padding 0 20px
		background-color #FFF
		
	.feature-icon
		background-color #FFF
		width 160px
		height 160px
		border-radius 100%
		box-shadow 0px 20px 40px #00000029
		font-size 18px
		font-weight 300
		display flex
		justify-content center
		align-items flex-end
		padding-top	20px
		
		p
			position relative
			top 60px
			margin-bottom 0

		&.one
			background url('~@/assets/img/icons/star-orange.svg') center center / 60% no-repeat #fff
		&.two
			background url('~@/assets/img/icons/money-purple.svg') center center / 60% no-repeat #fff
		&.three
			background url('~@/assets/img/icons/piggy-blue.svg') center center / 60% no-repeat #fff
		&.four
			background url('~@/assets/img/icons/tree-green.svg') center center / 60% no-repeat #fff
			
	.feature-spacer
		width 100px
		display flex
		justify-content center
		align-items center
		
		.stroke
			width 32%
			border none
			border-top 2px solid #CCCCCC
			height 2px
		
	.feature-spacer-inner
		border 2px solid #CCCCCC
		border-radius 100%
		padding 5px
		font-size 30px
		font-weight 300
		line-height 1
		width 35px
		height 35px
		display flex
		justify-content center
		align-items center
		color #CCCCCC
		
	.feature-details,
	.feature-details .flex-row
		margin-bottom 200px
	
	.feature-details .img-half
		display flex
		justify-content center
		align-items center
		position relative
		min-height 370px
			
		img
			width 95%
			
		img.rewards-img-smaller
			width 80%
			
	.savings-detail
		margin-top 300px
		
	.detail-icon
		width 60px
		margin-bottom 10px
		
	.video-section h2
		text-align center
		margin-bottom 100px
		
	.testimonials-carousel
		margin 100px 0
		justify-content center
		align-items center
		width 90%
		max-width 1300px
		
	
	.stroke 
		border-top 1.5px solid #CCCCCC
		height 2px
		width 18%

	.testimonials-inner
		width 64%
		padding 40px
		border 2px solid #CCCCCC
		border-radius 30px
		justify-content center
		align-items center
		position relative

		&:before
			content url('~@/assets/img/home/open-quotes.svg')
			position absolute
			top 20px
			left 20px
			transform scale(.8)
		
		&:after
			content url('~@/assets/img/home/close-quotes.svg')
			position absolute
			bottom 20px
			right 20px
			transform scale(.8)
			
		

		img
			// margin-top -60px
			width 100px
			margin -80px auto 30px
			box-shadow 0px 20px 40px #00000029
			border-radius 100%
		
		.slide
			display flex
			flex-direction column
			justify-content space-between
			align-items center

		.slide .copy p
			font-size 14px
			text-align center
			&:first-of-type
				min-height 150px

			&.author
				font-size 24px
				font-weight bold
				padding-bottom 4px

	.multi-experience
		background: url('~@/assets/img/bgs/multi-experience-bg.jpg') center top / 100% no-repeat #f7f7f7
		padding 300px 0
		text-align center
		
		p.text-center
			margin-bottom 80px
			
		img 
			height 55px
			margin-bottom 10px
		
		.one-third 
			margin-bottom 60px
			text-align left	
			width 30% !important
			
		.one-third p strong
			font-size 24px
			line-height 32px
			font-weight bold
			
		button 
			margin 0 auto
			
	.home-demo
		margin-top -160px
		
		.demo-inner
			text-align center

	.padding-left-half
		padding-left 50px
		
	.padding-right-half
		padding-right 40px
	
	@media (min-width: 2000px)
		.home-demo
			margin-top -260px
			
	@media (max-width: 1300px)
		.hero-copy-container.one-half
			margin-top -60px
			
		h1.hero-header
			font-size 58px	
			
		p.hero-body
			font-size 15px
			margin-bottom 8px
		
	@media (max-width: 1000px)
		.bg-container.home-hero 
			background url('~@/assets/img/bgs/sub-page-hero-bg.svg') center center / cover no-repeat
			
			h1.hero-header
				font-size 12vw
			
		.flex-row.breakdown .hero-silhouette.one-half
			max-width 450px
			
		.hero-silhouette.one-half
			margin-bottom 60px
			
			img.home-silhouette
				width 100%
		
		.hero-screenshot-container .give-screen 
			width 32%
			top -150px
			left 10px
		.hero-screenshot-container .get-screen 
			width 32%
			top -50px
			right 20px
		.hero-screenshot-container .plant-screen 
			width 32%
			top -134px
			right 44px
			
		.hero-copy-container.one-half
			margin-top 0
			
		.bg-container.home-hero .template-inner
			padding-top 170px
		
		.boosting.flex-row
			flex-direction column
			
			.one-third 
				width 100% !important
				margin-bottom 60px

		.flex-row.breakdown 
			flex-direction column
			
			.one-half
				width 100% !important
			
		.hero-copy-container.one-half
			margin-bottom 80px
			text-align center
			
			h1.hero-header,
			p.hero-body,
			button
				text-align center
			
		.hero-silhouette.one-half
			display block
			align-self center
		
		.counts-bg-green .align-start
			align-items center !important
			
		.trees-planted
			margin-top -50px
			padding 40px 30px
			width 112% !important
			
		p.count
			font-size 14.5vw !important	
		
		.padding-right-half,
		.padding-left-half
			padding 0
			
		.feature-details
			margin-bottom 120px 
			
		.feature-details .flex-row
			margin-bottom 50px

		.flex-row.savings-detail
			margin-top 0
			padding-top 100px

		.flex-row.rewards-detail,
		.flex-row.climate-action-detail 
			flex-direction column-reverse
			padding-top 70px
			
		.stroke
			display none
			
		.testimonials-inner
			width 100%

		.video-section
			margin-bottom 70px
			
		.video-container
			width 90%

		.multi-experience
			padding 120px 0 80px

			.one-third
				width 100% !important
		
		.home-demo
			margin-top 0
			
	// NEIL HERO CHANGES
	@media (min-width: 1100px)
		.template-inner.breakdown
			align-items initial

		.hero-copy-container.one-half 
			padding-top 80px
			
		h1.hero-header
			line-height 1.1

		p.hero-body 
			font-size 18px

</style>